/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import PropTypes from "prop-types";
import addEventListener from "dc-preview-utils/src/Utils/DomUtils";
import { SearchInputUIContainer } from "containers/search/SearchInputUIContainer";
import SearchUICss from "./SearchUI.css";
import classNames from "classnames";

const SearchInputWrapper = ({
  showSearchInputUI,
  enableSearchFeature,
  options: { color },
  isSinglePageMode,
  ...otherProps
}) => {
  if (!(showSearchInputUI && enableSearchFeature)) {
    return null;
  }
  let searchUIClassName = color === "dark" ? SearchUICss.SearchUIDarkTheme : SearchUICss.SearchUI;
  if (isSinglePageMode) {
    // searchUI is docked in single page mode
    searchUIClassName = classNames(searchUIClassName, SearchUICss.SearchUIDocked);
  }
  return (
    <div className={searchUIClassName} id="search-ui-container">
      <SearchInputUIContainer {...otherProps} options={{ color }} />
    </div>
  );
};

class SearchUI extends Component {
  onKeyDown = event => {
    this.props.onKeyDown(event);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.enableSearchFeature !== this.props.enableSearchFeature) {
      if (this.props.enableSearchFeature) {
        this._removeKeyDownListener = addEventListener(window, "keydown", this.onKeyDown);
      } else {
        this._removeKeyDownListener && this._removeKeyDownListener();
      }
    }
  }

  componentDidMount() {
    if (this.props.enableSearchFeature) {
      this._removeKeyDownListener = addEventListener(window, "keydown", this.onKeyDown);
    }
  }

  componentWillUnmount() {
    this._removeKeyDownListener && this._removeKeyDownListener();
  }

  render() {
    return <SearchInputWrapper {...this.props} />;
  }
}

SearchUI.propTypes = {
  showSearchInputUI: PropTypes.bool.isRequired,
  options: PropTypes.shape({
    color: PropTypes.string.isRequired
  }).isRequired,
  onKeyDown: PropTypes.func.isRequired
};

SearchUI.defaultProps = {};

export { SearchUI };
